import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "auth-page-container bg-white py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "tab-content bg-white rounded" }
const _hoisted_6 = {
  key: 0,
  class: "tab-pane fade show active"
}
const _hoisted_7 = {
  key: 1,
  class: "tab-pane fade show active"
}
const _hoisted_8 = {
  key: 2,
  class: "tab-pane fade show active"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Login = _resolveComponent("Login")!
  const _component_Register = _resolveComponent("Register")!
  const _component_ForgotPassword = _resolveComponent("ForgotPassword")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.activeTab === 'login')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_Login, {
                    onLoginSuccess: _ctx.handleAuthSuccess,
                    onSwitchToRegister: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchTab('register'))),
                    onSwitchToForgot: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTab('forgot')))
                  }, null, 8, ["onLoginSuccess"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'register')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_Register, {
                    onRegisterSuccess: _ctx.handleAuthSuccess,
                    onSwitchToLogin: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchTab('login')))
                  }, null, 8, ["onRegisterSuccess"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'forgot')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_ForgotPassword, {
                    isModal: false,
                    onForgotSuccess: _ctx.handleForgotSuccess,
                    onSwitchToLogin: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchTab('login')))
                  }, null, 8, ["onForgotSuccess"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}